import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface IWorkflowDetails {
	type: string;
	data: any;
}

export interface IWorkflowModuleState {
	queueDrawer: boolean;
	queueDetails: IWorkflowDetails;
	createQueueFlag: boolean;
	workflowStepDrawer: boolean;
	workflowStepDetails: IWorkflowDetails;
	createWorkflowStepFlag: boolean;
	editQueueFlag: boolean;
}

const initialState: IWorkflowModuleState = {
	queueDrawer: false,
	queueDetails: { type: '', data: {} },
	createQueueFlag: false,
	editQueueFlag: false,
	workflowStepDrawer: false,
	workflowStepDetails: { type: '', data: {} },
	createWorkflowStepFlag: false,
};

export const workflowSlice = createSlice({
	name: 'workflowmodule',
	initialState,
	reducers: {
		setQueueDrawer: (state, action: PayloadAction<boolean>) => {
			state.queueDrawer = action.payload;
		},
		setQueueDetails: (state, action: PayloadAction<IWorkflowDetails>) => {
			state.queueDetails = action.payload;
		},
		setCreateQueueFlag: (state, action: PayloadAction<boolean>) => {
			state.createQueueFlag = action.payload;
		},
		setWorkflowStepDrawer: (state, action: PayloadAction<boolean>) => {
			state.workflowStepDrawer = action.payload;
		},
		setWorkflowStepDetails: (
			state,
			action: PayloadAction<IWorkflowDetails>,
		) => {
			state.workflowStepDetails = action.payload;
		},
		setWorkflowStepFlag: (state, action: PayloadAction<boolean>) => {
			state.createWorkflowStepFlag = action.payload;
		},
		setEditQueueFlag: (state, action: PayloadAction<boolean>) => {
			state.editQueueFlag = action.payload;
		},
	},
});

export const {
	setQueueDrawer,
	setQueueDetails,
	setCreateQueueFlag,
	setWorkflowStepDrawer,
	setWorkflowStepDetails,
	setWorkflowStepFlag,
	setEditQueueFlag,
} = workflowSlice.actions;
export default workflowSlice.reducer;
